const url = "https://apidlog-astra.astrainovacoes.com.br"

export { url };